import React from 'react';
import { DropdownButton } from 'react-bootstrap';
import { DeleteBlueIcon } from '../icons/DeleteBlueIcon.jsx';
import { EditBlueIcon } from '../icons/EditBlueIcon.jsx';
import CustomMenuItem from '../CustomMenuItem.jsx';

const EmployeeActionDropdown = ({
  employee,
  onEdit,
  onDelete,
  actionsPosition,
}) => {
  return (
    <div className={`actions ${actionsPosition}`}>
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        <span>
          <CustomMenuItem onClick={() => onEdit(employee.id)}>
            <span className="flex">
              <EditBlueIcon />
              <span>&nbsp; Edit</span>
            </span>
          </CustomMenuItem>
          <CustomMenuItem divider />
        </span>

        <CustomMenuItem>
          <button
            className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
            onClick={() => onDelete(employee)}
          >
            <DeleteBlueIcon />
            &nbsp; Delete
          </button>
        </CustomMenuItem>
      </DropdownButton>
    </div>
  );
};

export default EmployeeActionDropdown;
